export default "__VITE_ASSET__BSp56C2K__"